import { useEffect, useState } from 'react';

import { UserBadge } from '@/features/auth/components/UserBadge';

import { HeaderNotificationsDropdown } from './HeaderNotificationsDropdown';

function LiveClock() {
  const [time, setTime] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <span
      style={{
        fontSize: 11,
        color: 'var(--text-secondary)',
        fontVariantNumeric: 'tabular-nums',
        fontWeight: 500,
      }}
    >
      {time.toLocaleTimeString('vi-VN')}
    </span>
  );
}

/**
 * Cụm bên phải header ứng dụng: thông báo (chuông + badge), đồng hồ, người dùng.
 * Dùng chung Dashboard và khu vực Vận hành (Ops).
 */
export function AppHeaderUserControls() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <HeaderNotificationsDropdown />
      <div
        style={{
          padding: '5px 14px',
          borderRadius: 20,
          background: 'var(--mdm-header-tint)',
          border: '1px solid var(--glass-border)',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <LiveClock />
      </div>
      <div style={{ width: 1, height: 20, background: 'var(--glass-border)' }} />
      <UserBadge dropdownPlacement="bottomRight" />
    </div>
  );
}
